<div class="row" [ngClass]="!isGrid ? 'd-flex row align-items-center' : ''">
  @for (option of options; track option; let i = $index) {
    <div
      (click)="selectOption(option)"
      [ngClass]="{
        active: option.value === value,
        'col-xs-12 col-sm-12 col-md-6': !isGrid,
      }"
    >
      <ng-template #defaultOption>
        <p>this is default template</p>
      </ng-template>
      <ng-container
        [ngTemplateOutlet]="optionTemplateRef || defaultOption"
        [ngTemplateOutletContext]="{ $implicit: option, index: i }"
      >
      </ng-container>
    </div>
  }
</div>
